<template>
	<button
		type="button"
		class="v2im-sort-btn"
		:class="{ 'v2im-sort-btn--active': isActive }"
		:disabled="disabled"
		:aria-label="ariaLabel"
		@click="$emit('ordering', name)"
	>
		<span><slot /></span>
		<svg v-if="isActive && !descending" class="v2im-sort-btn__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m6 9 6 6 6-6"/></svg>
		<svg v-else-if="isActive && descending" class="v2im-sort-btn__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m18 15-6-6-6 6"/></svg>
		<svg v-else class="v2im-sort-btn__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 9l4-4 4 4"/><path d="M16 15l-4 4-4-4"/></svg>
	</button>
</template>


<script>
export default {
	name: 'V2ThOrderingButton',

	props: {
		name: { type: String, required: true },
		orderBy: { type: String, default: null },
		descending: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
	},

	computed: {
		isActive() {
			return this.name === this.orderBy;
		},
		ariaLabel() {
			if (this.isActive) {
				return this.descending ? 'Sorted descending' : 'Sorted ascending';
			}
			return 'Order by';
		},
	},
};
</script>


<style lang="sass" scoped>
@import '~@/assets/styles/v2-tokens.sass'

.v2im-sort-btn
	display: inline-flex
	align-items: center
	gap: 4px
	cursor: pointer
	background: none
	border: none
	font: inherit
	color: inherit
	padding: 0
	text-transform: inherit
	letter-spacing: inherit

	&:disabled
		cursor: not-allowed
		opacity: 0.5

.v2im-sort-btn__icon
	width: 10px
	height: 10px
	opacity: 0.5
	transition: opacity 0.15s

.v2im-sort-btn:hover .v2im-sort-btn__icon
	opacity: 1

.v2im-sort-btn--active
	color: $v2-teal

	.v2im-sort-btn__icon
		opacity: 1
</style>
